const messages = {
  de: {
    register: 'Registrieren',
    join_now: 'Beitreten',
    select_stream_below: 'Bitte wählen Sie die Streaming Qualität aus',
    please_write_your_question: 'Sie können hier Ihre Frage stellen',
    change: 'ändern',
    save: 'Speichern',
    cancel: 'Wiederrufen',
    send: 'Senden',
    sending: 'Sending...',
    name: 'Name',
    okey: 'Okey',
    city_or_country: 'Stadt oder Land',
    please_register: 'Anmeldung',
    please_wait: 'Bitte warten',
    please_enter_your_name:
      'Bitte geben Sie Ihren Namen und Ihren Standort ein, bevor Sie eine Frage senden.',
    hide_questions: 'Fragen sind nur für den Sprecher sichtbar',
    add_to_calendar: 'Add to Calendar',
    livecast_will_start_in: 'Übertragung startet {time}',
    form_validation_error: 'Validation Error',
    registration_form_error: 'Please fix errors on registration form.',
    send_question_success: 'Your question has been sent.',
    send_question_error: 'Error sending question!',
    required_field_error: 'This field is required',
    invalid_field_error: 'invalid {fieldName} format',
    regform_selectBoxOther: 'Other',
    thanks_for_registering: 'Thanks for registering!',
    confirmation_mail_sent:
      'A confirmation email with webcast link has been sent to your email address.',
    join_15_min_before: 'Please use the link 15 min. join to the webcast'
  }
}

export default messages
